import useNotifications from '@/components/Notification/useNotifications';
import { useMutation } from '@tanstack/react-query';

import useMelingo from './useMelingo';

interface ChatRequest {
  message: string; // The user's message or query
  chat_id: string; // Unique identifier for the chat session
}
export interface ChatResponse {
  reply: string; // The chatbot's response or reply to the user
  query: string; // The user's input or query
  type: string; // Type of interaction (e.g., "normal")
  data?: string;
}

const useSendChatMessage = () => {
  const { showErrorNotification } = useNotifications();
  const { queryCall } = useMelingo();

  const mutationOptions = {
    mutationFn: async (
      variables: ChatRequest
    ): Promise<ChatResponse | undefined> => {
      try {
        const response = await queryCall(variables);
        if (response.ok) {
          return await response.json();
        } else {
          const errorResponse = await response.json();

          showErrorNotification({
            autoClose: 4000,
            position: 'top-right',
            title: `Oops! An error occurred while sending the message.`,
            message: errorResponse.title + ' (' + errorResponse.detail + ')'
          });
        }
      } catch (ex) {
        console.debug(ex);
        showErrorNotification({
          autoClose: 4000,
          position: 'top-right',
          title: `Oops! An error occurred while sending the message.`,
          message: ex instanceof Error ? ex.message : String(ex)
        });
      }
    }
  };
  const mutation = useMutation(mutationOptions);

  const sendChatMessage = async (
    message: string,
    chatId: string
  ): Promise<ChatResponse | undefined> => {
    try {
      const chatResponse = await mutation.mutateAsync({
        chat_id: chatId,
        message: message
      });
      return chatResponse;
    } catch {
      //
    }
  };

  return { sendChatMessage };
};

export default useSendChatMessage;
